module.exports = __webpack_public_path__ + "static/media/11_insideyourblood.f118e148.jpg";